/**
 * Slider GUI component
 */

import { Slider, Text, Box, Group } from "@mantine/core";
import type { GuiSliderElement } from "../types";
import { useWebSocket } from "../WebSocket";
import { useViewerStore } from "../store";

interface GuiSliderProps {
  element: GuiSliderElement;
}

export function GuiSlider({ element }: GuiSliderProps) {
  const { sendGuiEvent } = useWebSocket();
  const updateGuiValue = useViewerStore((state) => state.updateGuiValue);

  const handleChange = (value: number) => {
    // Update local state immediately for responsive UI
    updateGuiValue(element.uuid, value);
  };

  const handleChangeEnd = (value: number) => {
    // Send to Python backend
    sendGuiEvent(element.uuid, "change", value);
  };

  return (
    <Box style={{ marginBottom: "12px" }}>
      <Group justify="space-between" mb={4}>
        <Text size="sm">{element.label}</Text>
        <Text size="xs" c="dimmed">
          {element.value.toFixed(3)}
        </Text>
      </Group>
      <Slider
        value={element.value}
        onChange={handleChange}
        onChangeEnd={handleChangeEnd}
        min={element.min}
        max={element.max}
        step={element.step}
        disabled={element.disabled}
        size="sm"
      />
    </Box>
  );
}
